<template>
  <div class="splash-screen">
    <img src="assets/icons/robot.svg">
  </div>
</template>

<script>
export default {
  name: "SplashScreen"
};
</script>

<style scoped>
.splash-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--background);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  z-index: 9999;
}

.splash-screen img {
  animation: rotate-img-splash-screen 2.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) both;
  width: 15%;
  max-width: 150px;
}

@keyframes rotate-img-splash-screen {
  0% {
    opacity: 0.2;
    scale: 0;
    transform: rotateY(0deg);
  }

  100% {
    opacity: 1;
    transform: rotateY(360deg);
    scale: 1;
  }
}
</style>
